import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { OnboardingEnvironment } from './environment';
import { SafePromise } from '@benzinga/safe-await';
import {
  IterableWorkflowRequest,
  IterableWorkflowResponse,
  MarketInterestResponse,
  OnboardingDataResponse,
  OnboardingUserQuestionsPayload,
  PortfolioResponse,
} from './entities';

export class OnboardingRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(OnboardingEnvironment).url, session, { 'x-device-key': true });
  }

  public setMarketInterest = (
    interest: string,
    userHubspotId: string | undefined,
  ): SafePromise<MarketInterestResponse> => {
    const url = this.URL('profile/portfolio/api/hubspot');
    return this.post(url, {
      params: {
        hubspot_id: userHubspotId,
        reason: interest,
      },
    });
  };

  public getPortfolioAccessToken = (): SafePromise<PortfolioResponse> => {
    const url = new URL('api/v2/watchlists/yodlee/auth', this.session.getEnvironment(OnboardingEnvironment).rootUrl);
    return this.post(url, null, {
      includeHeader: {
        'x-csrf-token': true,
        'x-session-key': true,
      },
    });
  };

  public getOnboardingData = (): SafePromise<OnboardingDataResponse> => {
    const url = this.URL('research/api2/onboarding-data');
    return this.get(url, { allowsAnonymousAuth: true });
  };

  public submitOnboardingUserQuestions = (body: OnboardingUserQuestionsPayload): SafePromise<unknown> => {
    const url = this.URL('research/api2/onboarding-user-questions');
    return this.post(url, body, { credentials: 'omit' });
  };

  public triggerIterableWorkflow = (body: IterableWorkflowRequest): SafePromise<IterableWorkflowResponse> => {
    const url = this.URL('api-next/iterable-workflow');
    return this.post(url, body, { allowsAnonymousAuth: true });
  };
}
